(function () {
  'use strict';

  var Z = window.Zenvyra || {};
  var routes = Z.routes || { cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cart: '/cart.js' };

  function money(cents) {
    var fmt = Z.moneyFormat || '\u20ac{{amount}}';
    var value = (cents / 100).toFixed(2).replace('.', ',');
    var plain = (cents / 100).toFixed(2);
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, value)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_period\s*\}\}/g, plain);
  }

  /* ---------- Cart drawer ---------- */
  var drawer, overlay;

  function openCart() {
    if (!drawer) return;
    drawer.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!drawer) return;
    drawer.removeAttribute('data-open');
    document.body.style.overflow = '';
  }

  function renderCart(cart) {
    var countEls = document.querySelectorAll('[data-cart-count]');
    countEls.forEach(function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });

    var body = drawer && drawer.querySelector('[data-cart-body]');
    var footer = drawer && drawer.querySelector('[data-cart-footer]');
    var empty = drawer && drawer.querySelector('[data-cart-empty]');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = '';
      if (empty) empty.style.display = 'flex';
      if (footer) footer.style.display = 'none';
      return;
    }
    if (empty) empty.style.display = 'none';
    if (footer) footer.style.display = 'block';

    body.innerHTML = cart.items.map(function (item) {
      var img = item.image ? item.image.replace(/(\.[^.]*)$/, '_120x120$1') : '';
      return '' +
        '<div style="display:flex;gap:16px;align-items:center;background:var(--surface);border:1px solid var(--border);border-radius:14px;padding:14px">' +
          (img ? '<img src="' + img + '" alt="" style="width:64px;height:64px;border-radius:10px;object-fit:cover;flex:none">' : '<div style="width:64px;height:64px;border-radius:10px;background:var(--surface);flex:none"></div>') +
          '<div style="flex:1;min-width:0">' +
            '<div style="font-size:15px;font-weight:600;color:var(--text)">' + item.product_title + '</div>' +
            '<div style="font-size:13px;color:var(--muted);margin-top:2px">' + money(item.final_price) + '</div>' +
            '<div style="display:flex;align-items:center;gap:12px;margin-top:10px">' +
              '<div style="display:flex;align-items:center;border:1px solid var(--border-strong);border-radius:8px;overflow:hidden">' +
                '<button data-qty="' + item.key + '" data-delta="-1" style="background:transparent;border:none;color:var(--text);width:28px;height:28px;cursor:pointer;font-size:16px">\u2212</button>' +
                '<span style="width:30px;text-align:center;color:var(--text);font-size:14px">' + item.quantity + '</span>' +
                '<button data-qty="' + item.key + '" data-delta="1" style="background:transparent;border:none;color:var(--text);width:28px;height:28px;cursor:pointer;font-size:16px">+</button>' +
              '</div>' +
              '<button data-remove="' + item.key + '" style="background:transparent;border:none;color:var(--faint);cursor:pointer;font-size:13px">Retirer</button>' +
            '</div>' +
          '</div>' +
        '</div>';
    }).join('');

    var totalEl = drawer.querySelector('[data-cart-total]');
    if (totalEl) totalEl.textContent = money(cart.total_price);
  }

  function fetchCart() {
    return fetch(routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  function addToCart(id, qty) {
    return fetch(routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    }).then(function (r) { return r.json(); }).then(function () {
      return fetchCart();
    }).then(function () { openCart(); });
  }

  function buyNow(id, qty) {
    return fetch(routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    }).then(function () { window.location.href = '/checkout'; });
  }

  function changeQty(key, quantity) {
    return fetch(routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  /* ---------- Accordion (FAQ categories) ---------- */
  function initAccordions() {
    document.querySelectorAll('[data-accordion]').forEach(function (root) {
      root.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var panel = trigger.parentElement.querySelector('[data-accordion-panel]');
          var chevron = trigger.querySelector('[data-chevron]');
          var open = panel.getAttribute('data-open') === 'true';
          if (open) {
            panel.style.maxHeight = '0px';
            panel.setAttribute('data-open', 'false');
            if (chevron) chevron.style.transform = 'rotate(0deg)';
          } else {
            panel.style.maxHeight = panel.scrollHeight + 40 + 'px';
            panel.setAttribute('data-open', 'true');
            if (chevron) chevron.style.transform = 'rotate(180deg)';
          }
        });
      });
    });
  }

  /* ---------- FAQ search ---------- */
  function initFaqSearch() {
    var input = document.querySelector('[data-faq-search]');
    if (!input) return;
    var noResults = document.querySelector('[data-faq-noresults]');
    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase();
      var visible = 0;
      document.querySelectorAll('[data-faq-cat]').forEach(function (cat) {
        var text = cat.getAttribute('data-search') || cat.textContent;
        var match = !q || text.toLowerCase().indexOf(q) !== -1;
        cat.style.display = match ? '' : 'none';
        if (match) visible++;
        if (q) {
          var panel = cat.querySelector('[data-accordion-panel]');
          var chevron = cat.querySelector('[data-chevron]');
          if (panel) { panel.style.maxHeight = panel.scrollHeight + 40 + 'px'; panel.setAttribute('data-open', 'true'); }
          if (chevron) chevron.style.transform = 'rotate(180deg)';
        }
      });
      if (noResults) noResults.style.display = visible === 0 ? 'block' : 'none';
    });
  }

  /* ---------- Reviews carousel ---------- */
  function initCarousels() {
    document.querySelectorAll('[data-carousel]').forEach(function (root) {
      var track = root.querySelector('[data-carousel-track]');
      var prev = root.querySelector('[data-carousel-prev]');
      var next = root.querySelector('[data-carousel-next]');
      if (!track) return;
      var amount = function () { return track.clientWidth * 0.8; };
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -amount(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: amount(), behavior: 'smooth' }); });
    });
  }

  /* ---------- Product gallery + zoom + lightbox ---------- */
  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (root) {
      var main = root.querySelector('[data-gallery-main]');
      var zoomBox = root.querySelector('[data-gallery-zoom]');
      var thumbs = [].slice.call(root.querySelectorAll('[data-gallery-thumb]'));

      function setMain(thumb) {
        var src = thumb.getAttribute('data-src');
        var full = thumb.getAttribute('data-full') || src;
        if (src && main) { main.src = src; main.setAttribute('data-full', full); }
        thumbs.forEach(function (t) { t.setAttribute('data-active', 'false'); });
        thumb.setAttribute('data-active', 'true');
      }
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () { setMain(thumb); });
      });

      /* prev / next arrows on the main image */
      function step(dir) {
        if (!thumbs.length) return;
        var activeIdx = thumbs.findIndex
          ? thumbs.findIndex(function (t) { return t.getAttribute('data-active') === 'true'; })
          : (function () { for (var k = 0; k < thumbs.length; k++) { if (thumbs[k].getAttribute('data-active') === 'true') return k; } return 0; })();
        if (activeIdx < 0) activeIdx = 0;
        var ni = (activeIdx + dir + thumbs.length) % thumbs.length;
        setMain(thumbs[ni]);
      }
      var prevBtn = root.querySelector('[data-gallery-prev]');
      var nextBtn = root.querySelector('[data-gallery-next]');
      if (prevBtn) prevBtn.addEventListener('click', function (e) { e.stopPropagation(); step(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function (e) { e.stopPropagation(); step(1); });

      /* hover zoom on desktop */
      if (zoomBox && main && window.matchMedia('(hover: hover)').matches) {
        zoomBox.addEventListener('mousemove', function (e) {
          var r = zoomBox.getBoundingClientRect();
          var x = (e.clientX - r.left) / r.width * 100;
          var y = (e.clientY - r.top) / r.height * 100;
          main.style.transformOrigin = x + '% ' + y + '%';
          main.style.transform = 'scale(2)';
        });
        zoomBox.addEventListener('mouseleave', function () {
          main.style.transform = 'scale(1)';
        });
      }

      /* click opens lightbox */
      if (zoomBox) {
        zoomBox.addEventListener('click', function () {
          var list = thumbs.length ? thumbs.map(function (t) { return t.getAttribute('data-full') || t.getAttribute('data-src'); })
                                   : [main.getAttribute('data-full') || main.src];
          var current = main.getAttribute('data-full') || main.src;
          var idx = list.indexOf(current);
          openLightbox(list, idx < 0 ? 0 : idx);
        });
      }
    });
  }

  /* ---------- Lightbox ---------- */
  function openLightbox(list, startIndex) {
    var lb = document.querySelector('[data-lightbox]');
    if (!lb) return;
    var img = lb.querySelector('[data-lightbox-img]');
    var i = startIndex || 0;
    var scale = 1, tx = 0, ty = 0, dragging = false, sx = 0, sy = 0;

    function apply() {
      img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
      img.style.cursor = scale > 1 ? 'grab' : 'zoom-in';
    }
    function reset() { scale = 1; tx = 0; ty = 0; apply(); }
    function show() { img.src = list[i]; reset(); }

    lb._show = show; lb._list = list;
    show();
    lb.style.display = 'flex';
    document.body.style.overflow = 'hidden';

    function go(d) { i = (i + d + list.length) % list.length; show(); }
    lb._go = go;

    /* wheel zoom */
    lb._wheel = function (e) {
      e.preventDefault();
      var delta = e.deltaY < 0 ? 0.2 : -0.2;
      scale = Math.min(5, Math.max(1, scale + delta));
      if (scale === 1) { tx = 0; ty = 0; }
      apply();
    };
    lb.addEventListener('wheel', lb._wheel, { passive: false });

    /* drag pan */
    img.onmousedown = function (e) { if (scale === 1) return; dragging = true; sx = e.clientX - tx; sy = e.clientY - ty; img.style.cursor = 'grabbing'; e.preventDefault(); };
    window.onmousemove = function (e) { if (!dragging) return; tx = e.clientX - sx; ty = e.clientY - sy; apply(); };
    window.onmouseup = function () { dragging = false; if (scale > 1) img.style.cursor = 'grab'; };

    /* click image toggles zoom (when not dragging) */
    img.onclick = function (e) { e.stopPropagation(); scale = scale > 1 ? 1 : 2.5; if (scale === 1) { tx = 0; ty = 0; } apply(); };

    /* pinch zoom (touch) */
    var pd = 0;
    lb._touchmove = function (e) {
      if (e.touches.length === 2) {
        e.preventDefault();
        var d = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY);
        if (pd) { scale = Math.min(5, Math.max(1, scale + (d - pd) / 200)); apply(); }
        pd = d;
      }
    };
    lb._touchend = function () { pd = 0; };
    lb.addEventListener('touchmove', lb._touchmove, { passive: false });
    lb.addEventListener('touchend', lb._touchend);
  }

  function closeLightbox() {
    var lb = document.querySelector('[data-lightbox]');
    if (!lb) return;
    lb.style.display = 'none';
    document.body.style.overflow = '';
    if (lb._wheel) lb.removeEventListener('wheel', lb._wheel);
    if (lb._touchmove) lb.removeEventListener('touchmove', lb._touchmove);
    if (lb._touchend) lb.removeEventListener('touchend', lb._touchend);
    window.onmousemove = null; window.onmouseup = null;
  }

  function initLightbox() {
    var lb = document.querySelector('[data-lightbox]');
    if (!lb) return;
    lb.querySelector('[data-lightbox-close]').addEventListener('click', function (e) { e.stopPropagation(); closeLightbox(); });
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target.hasAttribute('data-lightbox-stage')) closeLightbox(); });
    var prev = lb.querySelector('[data-lightbox-prev]');
    var next = lb.querySelector('[data-lightbox-next]');
    if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); if (lb._go) lb._go(-1); });
    if (next) next.addEventListener('click', function (e) { e.stopPropagation(); if (lb._go) lb._go(1); });
    document.addEventListener('keydown', function (e) {
      if (lb.style.display !== 'flex') return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft' && lb._go) lb._go(-1);
      if (e.key === 'ArrowRight' && lb._go) lb._go(1);
    });
  }

  /* ---------- Bundle (packs) selector ---------- */
  function initBundle() {
    document.querySelectorAll('[data-bundle]').forEach(function (root) {
      var cards = root.querySelectorAll('[data-bundle-card]');
      var form = document.querySelector('[data-product-form]');
      function select(card) {
        cards.forEach(function (c) { c.setAttribute('data-selected', c === card ? 'true' : 'false'); });
        var qty = card.getAttribute('data-qty');
        if (form) {
          var qtyEl = form.querySelector('[name="quantity"]');
          if (qtyEl) qtyEl.value = qty;
        }
        var label = document.querySelector('[data-bundle-total]');
        if (label) label.textContent = card.getAttribute('data-price');
      }
      cards.forEach(function (card) {
        card.addEventListener('click', function () { select(card); });
      });
      var def = root.querySelector('[data-bundle-card][data-default="true"]') || cards[0];
      if (def) select(def);
    });
  }

  /* ---------- Wire up ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    drawer = document.querySelector('[data-cart-drawer]');

    document.querySelectorAll('[data-open-cart]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
    });
    if (drawer) {
      drawer.querySelectorAll('[data-close-cart]').forEach(function (b) {
        b.addEventListener('click', closeCart);
      });
      drawer.addEventListener('click', function (e) {
        if (e.target.hasAttribute('data-qty')) {
          var key = e.target.getAttribute('data-qty');
          var delta = parseInt(e.target.getAttribute('data-delta'), 10);
          var span = e.target.parentElement.querySelector('span');
          var current = parseInt(span.textContent, 10) || 0;
          changeQty(key, Math.max(0, current + delta));
        }
        if (e.target.hasAttribute('data-remove')) {
          changeQty(e.target.getAttribute('data-remove'), 0);
        }
      });
    }

    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var id = form.querySelector('[name="id"]').value;
        var qtyEl = form.querySelector('[name="quantity"]');
        addToCart(id, qtyEl ? parseInt(qtyEl.value, 10) : 1);
      });
      var buy = form.querySelector('[data-buy-now]');
      if (buy) {
        buy.addEventListener('click', function (e) {
          e.preventDefault();
          var id = form.querySelector('[name="id"]').value;
          var qtyEl = form.querySelector('[name="quantity"]');
          buyNow(id, qtyEl ? parseInt(qtyEl.value, 10) : 1);
        });
      }
    });

    initAccordions();
    initFaqSearch();
    initCarousels();
    initGallery();
    initLightbox();
    initBundle();
    if (drawer) fetchCart();
  });
})();
